import React from 'react';

const GooglePay = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={55} height={24} viewBox="0 0 55 24" fill="none" {...props}>
    <path
      fill="#4285F4"
      d="M21.518 12.298c0-.62-.07-1.239-.139-1.858h-8.687v3.511h4.934c-.208 1.102-.834 2.134-1.807 2.754v2.272h2.989c1.737-1.583 2.71-3.924 2.71-6.678"
    />
    <path
      fill="#34A853"
      d="M12.691 21.182c2.502 0 4.587-.826 6.116-2.203l-2.988-2.273c-.835.551-1.877.895-3.128.895-2.363 0-4.448-1.583-5.143-3.786H4.49v2.34c1.599 3.099 4.726 5.027 8.201 5.027Z"
    />
    <path
      fill="#FBBC04"
      d="M7.548 13.814c-.417-1.102-.417-2.341 0-3.512v-2.34H4.49c-1.32 2.547-1.32 5.577 0 8.193l3.058-2.341Z"
    />
    <path
      fill="#EA4335"
      d="M12.691 6.584a5.2 5.2 0 0 1 3.545 1.377l2.64-2.616c-1.667-1.515-3.891-2.41-6.115-2.341-3.475 0-6.672 1.928-8.2 5.026l3.057 2.341c.625-2.203 2.71-3.787 5.073-3.787Z"
    />
    <path
      fill="#224251"
      d="M29.89 19V7.64h4.063c1.1 0 1.987.331 2.664.993.677.661 1.016 1.536 1.016 2.625 0 1.078-.339 1.95-1.016 2.617s-1.565 1-2.664 1h-2.492V19h-1.57Zm1.57-5.438h2.243c.75 0 1.32-.205 1.711-.617.396-.416.594-.979.594-1.687 0-.708-.198-1.268-.594-1.68-.39-.417-.96-.625-1.71-.625H31.46v4.61Zm6.892 3.47c0-.876.442-1.542 1.328-2 .89-.46 2.172-.704 3.843-.735v-.164c0-.594-.174-1.06-.523-1.399-.349-.343-.805-.515-1.367-.515-.412 0-.834.07-1.266.21a3.83 3.83 0 0 0-1.101.555l-.43-.93c.349-.301.792-.541 1.328-.718a4.997 4.997 0 0 1 1.617-.274c1.005 0 1.805.287 2.399.86.599.568.898 1.349.898 2.344V19h-1.492v-1.281c-.208.437-.576.786-1.102 1.047a3.77 3.77 0 0 1-1.695.39 3.13 3.13 0 0 1-1.187-.218 2.063 2.063 0 0 1-.891-.711c-.24-.329-.36-.727-.36-1.196Zm1.57-.157c0 .328.107.594.32.797.219.203.508.305.867.305a2.26 2.26 0 0 0 1.72-.743c.463-.494.694-1.132.694-1.914v-.078c-1.15.031-2.039.19-2.664.477-.625.286-.937.672-.937 1.156Zm6.21-5.523v-.125h1.65l2.202 6.171 2.164-6.171h1.602v.125l-3.477 9.007c-.479 1.26-1.257 1.891-2.336 1.891-.677 0-1.273-.14-1.789-.422l.383-1.039c.417.182.774.273 1.07.273.334 0 .597-.09.79-.273.192-.182.372-.469.539-.86l.242-.718-3.04-7.86Z"
    />
  </svg>
);

export default GooglePay;
